import React from 'react';

export const getScrollHiddenStyle = (): { [key: string]: React.CSSProperties } => ({
  '&::-webkit-scrollbar': {
    width: 0,
    height: 0,
  },
});
